import React, { useState, useRef } from "react";
import "../../css/Common.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

function CommunicationChannel({ value, onChange }) {
  const [tooltipStyle, setTooltipStyle] = useState({ display: "none" });
  const iconRef = useRef(null);

  const showTooltip = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setTooltipStyle({
        display: "block",
        top: `${rect.top + window.scrollY - 10}px`,
        left: `${rect.left + window.scrollX + rect.width + 20}px`,
      });
    }
  };

  const hideTooltip = () => {
    setTooltipStyle({ display: "none" });
  };

  const handleCheckboxChange = (type) => {
    onChange((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };

  const channels = [
    { id: "email", label: "Email", icon: "📧" },
    { id: "sms", label: "SMS", icon: "📱" },
    { id: "qr", label: "QR Code", icon: "📱" },
    { id: "voice", label: "Voice Call", icon: "📞" },
    { id: "social", label: "Social Media", icon: "🌐" },
  ];
  return (
    <div className="common-form-group">
      <div className="common-form-field">
        <div className="common-label-container">
          <label className="common-label-with-icon">
            Communication Channels
          </label>
          <FontAwesomeIcon
            ref={iconRef}
            icon={faCircleInfo}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            className="common-info-icon"
          />
        </div>
        <div className="control-tooltip" style={tooltipStyle}>
          Select which communication methods should be used for phishing
          simulations
        </div>
      </div>
      <div className="common-form-group">
        <div className="common-checkbox-container">
          <div className="common-columns">
            <div className="common-column">
              {channels.slice(0, 3).map((channel) => (
                <div key={channel.id} className="common-toggle-group">
                  <div className="common-toggle-info">
                    <h4>{channel.label}</h4>
                  </div>
                  <div
                    className={`common-toggle ${
                      value.includes(channel.id) ? "active" : ""
                    }`}
                    onClick={() => handleCheckboxChange(channel.id)}
                  />
                </div>
              ))}
            </div>

            <div className="common-column">
              {channels.slice(3, 5).map((channel) => (
                <div key={channel.id} className="common-toggle-group">
                  <div className="common-toggle-info">
                    <h4>{channel.label}</h4>
                  </div>
                  <div
                    className={`common-toggle ${
                      value.includes(channel.id) ? "active" : ""
                    }`}
                    onClick={() => handleCheckboxChange(channel.id)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommunicationChannel;
